export default __webpack_public_path__ + "static/media/opRequest.a8b20027.svg";